const state = () => ({
	languages: ['en'],
	selectedLang: 'en'
});

const getters = {};

const mutations = {
	setLanguages (state, languages) {
		state.languages = languages;
	},
	selectLang (state, selectedLang) {
		state.selectedLang = selectedLang;
	}
};

const actions = {};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
